import { settings } from '@springtree/eva-sdk-core-settings';
// Register the default settings
//
export const SETTINGS_GROUP_NAME = 'evaCoreService';
const defaultSettings = {
    // 30 seconds XHR timeout
    //
    defaultTimeout: 30000,
    // Cache endpoint data for 10 minutes
    //
    endpointCacheDuration: 600000,
    // Start without a currently selected station
    //
    currentStationID: undefined,
    // No default organization unit selections
    //
    requestedOrganizationUnitID: undefined,
    requestedOrganizationUnitQuery: undefined,
    // Rely on global fetch handler by default
    //
    fetch: undefined,
    // Start with an empty application token configuration
    //
    applicationTokens: {},
};
settings.register(SETTINGS_GROUP_NAME, defaultSettings);
/**
 * Retrieves the settings for the EvaService module
 *
 * @export
 * @returns {IEvaServiceSettings}
 */
export function getServiceSettings() {
    return settings.getGroup(SETTINGS_GROUP_NAME);
}
/**
 * Changes a setting for the EvaService module
 *
 * @export
 * @param {string} settingName
 * @param {*} setting
 * @returns {ISettingsChange}
 */
export function setServiceSetting(settingName, setting) {
    return settings.set(SETTINGS_GROUP_NAME, settingName, setting);
}
//# sourceMappingURL=settings.js.map